import React, { FC } from "react";

import "./Menu.scss";

import Logout from "../../assets/Logout.svg";

import useAppStore from "../Store/AppStore";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import CloseBtn from "./components/CloseBtn";
import {runtimeConfig} from "../../runtimeConfig";

const languages = [
    {
        name: "german",
        title: "Deutsch",
        abr: "de",
    },
    {
        name: "english",
        title: "English",
        abr: "en",
    },
    {
        name: "italian",
        title: "Italiano",
        abr: "it",
    },
    {
        name: "french",
        title: "Français",
        abr: "fr",
    },
];

const Menu: FC = () => {
    const { instance } = useMsal();

    const { t } = useTranslation();
    const lang = useAppStore((state) => state.activeLanguage);
    const setLang = useAppStore((state) => state.setLang);
    const environment = useAppStore((state) => state.environment)

    const setCurrentPopup = useAppStore((state) => state.setCurrentPopup);

    const handlePopupOpen = () => {
        setCurrentPopup("feedback");
    };

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    };

    const handleLanguageChange = (event) => {
        const languageSelected = event.target.id;
        setLang(languageSelected);
    };

    const onToggleEnvironment = () => {
        useAppStore.getState().setEnvironment(environment === "Development" ? "Showcase" : "Development")
    }

    return (
        <div className="flex flex-col w-[315px] max-h-[542px] p-5 bg-white rounded-md">
            <CloseBtn />
            <h2 className="popup-title">{t("Menu")}</h2>
            <div className="languages mt-[15px]">
                <p className="section-title">{t("Language")}</p>
                <ul className="languages-selection pt-[10px]">
                    {languages.map((language) => {
                        return (
                            <li key={language.name} className="py-[5px] flex items-center">
                                <input
                                    type="radio"
                                    id={language.abr}
                                    name="languages"
                                    value={language.name}
                                    className="language-radio-button"
                                    checked={language.abr === lang}
                                    onChange={handleLanguageChange}
                                />
                                <label htmlFor={language.name} className="language">
                                    {language.title}
                                </label>
                            </li>
                        );
                    })}
                </ul>
            </div>
            {useAppStore.getState().environment != "Showcase" && (
                <div className="feedback mt-[15px]">
                    <p className="section-title">{t("Feedback")}</p>
                    <p className="feedback-instructions mb-[10px]">
                        {t("Feedback Instructions")}
                    </p>
                    <div className="feedback-button-wrapper">
                        <button
                            className="button-primary button-border-gray button-text"
                            onClick={handlePopupOpen}
                        >
                            {t("Give feedback")}
                        </button>
                    </div>
                </div>
            )}
            {runtimeConfig.ENVIRONMENT === "Development" && (
                <div className="flex items-center slider-position">
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            checked={environment === "Showcase"}
                            onChange={onToggleEnvironment}
                        />
                        <span className="slider round"></span>
                    </label>
                    <span className="ml-2 text-sm">
                        {environment === "Showcase" ? "Showcase Active" : "Development Active"}
                    </span>
                </div>
            )}
            {useAppStore.getState().environment != "Showcase" && (
                <div className="logout mt-[15px]">
                    <div className="logout-button-wrapper">
                        <button
                            className="button-primary button-border-gray button-text flex justify-center items-center"
                            onClick={handleLogout}
                        >
                            <img src={Logout} className="inline pr-[5px] logout" />
                            {t("Logout")}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Menu;
